import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint, createFormField } from '@backstage/plugin-scaffolder-react/alpha';
import { ZipPasswordWidget } from './ZipPasswordWidget';

const zipPasswordField = FormFieldBlueprint.make({
  name: 'ZipPasswordWidget',
  params: {
    field: async () => createFormField({
      name: 'ZipPasswordWidget',
      component: ({ formData }) => <ZipPasswordWidget password={formData ?? ''} />,
    }),
  },
});

export const zipPasswordModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [zipPasswordField],
});
